import React from "react";
import "./Frame116.css";
import { Link, useHistory } from "react-router-dom";

function Frame116() {
  return (
    <Link to="/cur-performances">
    <div className="frame-116">
      <div className="result-objectives valign-text-middle inter-medium-star-dust-18px">Result &amp; Objectives</div>
    </div>
    </Link>
  );
}

export default Frame116;
